import { home } from './home2026'
import { rule } from './rule2026'
import { support } from './support'
import { works } from './works'

export {
  home,
  rule,
  support,
  works
}
